// extracted by mini-css-extract-plugin
module.exports = {"replies":"tweet-replies_replies__PUxl8","link":"tweet-replies_link__roxYQ","text":"tweet-replies_text__o0Naf"};